import { createGlobalState } from '@vueuse/core';
import $ from 'jquery';

const RAW_FLAG_ATTR = 'data-pretty-number-raw';
const RAW_VALUE_ATTR = 'data-pretty-number-raw-value';

// this is for validator to validate raw number (not formatted)
export const useInputPrettyNumberRaw = createGlobalState(() => {
    let valHookInstalled = false;

    function ensureValHookInstalled() {
        if(valHookInstalled) {
            return;
        }
        const hook = $.valHooks['text'];
        const prevGet = (hook && ('get' in hook)) ? hook.get : undefined;
        const prevSet = (hook && ('set' in hook)) ? hook.set : undefined;
        $.valHooks['text'] = {
            get(elem) {
                if(elem.getAttribute(RAW_FLAG_ATTR) === 'true') {
                    return elem.getAttribute(RAW_VALUE_ATTR) ?? '';
                }
                if(prevGet) {
                    return prevGet(elem);
                }
                return (elem as HTMLInputElement).value;
            },
            set(elem, value) {
                if(elem.getAttribute(RAW_FLAG_ATTR) === 'true') {
                    elem.setAttribute(RAW_VALUE_ATTR, String(value ?? ''));
                }
                if(prevSet) {
                    return prevSet(elem, value);
                }
                (elem as HTMLInputElement).value = String(value ?? '');
                return undefined;
            },
        };
        valHookInstalled = true;
    }

    function setRawDomValue(input: HTMLInputElement | undefined, value: string | null) {
        if(!input) {
            return;
        }
        input.setAttribute(RAW_VALUE_ATTR, value ?? '');
    }

    return {
        RAW_FLAG_ATTR,
        ensureValHookInstalled,
        setRawDomValue,
    };
});
